
import { connect } from "react-redux";
import { compose } from 'redux'
import { withRouter } from 'react-router-dom';
import { signinGoogle, signin } from '../../actions'

import { reduxForm } from 'redux-form'
function mapStateToProps({ AuthReducer }) {
  let errorMensage = "";
  if (AuthReducer.auth && AuthReducer.auth.crudError) {
    if (AuthReducer.auth.crudError.message)
      errorMensage = AuthReducer.auth.crudError.message;
    else
      errorMensage = AuthReducer.auth.crudError;
  }
  return { errorMensage };
}


export default compose(
  withRouter,
  connect(mapStateToProps, { signinGoogle, signin }),
  reduxForm({
    form: 'LoginForm',

  })

);


// WEBPACK FOOTER //
// ./src/routes/public/Login/components/SignIn/SignIn.enhancer.js